import { PaymentPlanStatus } from "Domain/PaymentPlan/Entity/PaymentPlan";
import { colors } from "@mui/material";
import StatusChip from "./StatusChip";
import { useTranslation } from "react-i18next";

type PaymentPlanStatusProps = {
  status: PaymentPlanStatus;
};

const statusColors: Record<PaymentPlanStatus, string> = {
  INIT: colors.grey[500],
  PENDING: colors.deepOrange[500],
  APPROVED: colors.indigo[500],
  FINISHED: colors.green[800],
  VALID: colors.indigo[600],
  DECLINED: colors.red[500],
  INVALID: colors.deepOrange[500],
  CANCELED: colors.grey[500],
  PARTIALLY_VALID: colors.orange[500],
};

export default function PaymentPlanStatusChip({
  status,
}: PaymentPlanStatusProps) {
  const { t } = useTranslation();
  const statusColor = status in statusColors ? statusColors[status] : "white";
  return (
    <StatusChip
      color={statusColor}
      label={t(`STATUS.LABEL.payment_plan.${status}`)}
      info={t(`STATUS.INFO.payment_plan.${status}`)}
    />
  );
}
